export default __webpack_public_path__ + "static/media/_DUA5005.0692ca47.jpg";